<div class="annotation " role="main"  *ngIf="outcome" >
  <div class="content-container pt-3">
  <h1  class="h-1 mt-0" tabindex="0">{{Annotationheader}}</h1>

  <table  mat-table [dataSource]="dataSource" matSort matSortActive="ParagraphId" matSortDirection="asc" aria-label="MyAnnotation" class="mt-3rem" aria-describedby="my annotation table">
    <ng-container matColumnDef="AnnotationTitle">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnone}}</th>
      <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='AnnotationTitle'?'#F0F5FF':null"> {{element.AnnotationTitle}} </td>
    </ng-container>

    <ng-container matColumnDef="Annotation">
      <th scope="col" mat-header-cell *matHeaderCellDef>{{annotationcolumntwo}}</th>
      <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='Annotation'?'#F0F5FF':null">
        {{element.Annotation}}
      </td>
    </ng-container>

    <ng-container matColumnDef="ParagraphId">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnthree}}</th>
      <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='ParagraphId'?'#F0F5FF':null">
        <span *ngFor="let items of element.Location; let i = index">
          <span *ngIf="i != element.Location.length-1">{{items}}</span>
          <img *ngIf="i != element.Location.length-1 && i != element.Location.length-2" class="arrow" alt="Arrow" src="../../../assets/icons/Arrow Right (Alt).svg" />
        </span><span><img class="arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right Down"></span>
        <br />
        <span class="link font-18 highlight-blue cursor-pointer" (click)="NavigateTo(element.AnnotationsURL,element.Location[element.Location.length-1], element.Location[element.Location.length-2], element.ParagraphId)" (keyup.enter)="NavigateTo(element.AnnotationsURL,element.Location[element.Location.length-1], element.Location[element.Location.length-2], element.ParagraphId)"> {{element.Location[element.Location.length-1]}} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="Date">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{annotationcolumnfour}}</th>
      <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='Date'?'#F0F5FF':null"> {{element.Date | date:'MM/dd/yyyy'}} </td>
    </ng-container>
    <ng-container matColumnDef="Action">
      <th scope="col" mat-header-cell *matHeaderCellDef>{{annotationcolumnfive}}</th>
      <td mat-cell *matCellDef="let element">
        <button aria-label="edit" mat-icon-button (click)="editAnnotations(element.id)" title="Edit" (keyup.enter)="editAnnotations(element.id)" tabindex="0">
          <mat-icon class="edit-icon"></mat-icon>
        </button>
        <button aria-label="copy" mat-icon-button (click)="copyToClipboard(element.id,element.AnnotationsURL,element.Annotation,element.Location)" title="Share" (keyup.enter)="copyToClipboard(element.id,element.AnnotationsURL,element.Annotation, element.Location)" tabindex="0">
          <mat-icon class="copy-clipboard-icon"></mat-icon>
        </button>
        <button aria-label="delete" mat-icon-button (click)="redirectToDelete(element.id)" (keyup.enter)="redirectToDelete(element.id)" title="Remove" tabindex="0">
          <mat-icon class="delete-icon"></mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div *ngIf="dataSource.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
  <div>
    <mat-paginator [pageSize]="pagesize" [pageSizeOptions]="pagelistarray"
                   aria-label="Select page of Annotations" appHostListenerClick>
    </mat-paginator>
  </div>
</div>
</div>
